<template>
	<div class="home_wrap">

		
		<div class="bannerswip">
			<van-swipe :autoplay="3000" lazy-render >
			  <van-swipe-item  v-for="(item, index) in banner" :key="index">
				<img :src="item[lang]" style="width: 100%;"/>
			  </van-swipe-item>
			</van-swipe>
		</div>

		<div class="ifm">
		    <div class="left">
		        <div>
		            <span>Hello</span>
		            <span>{{user.name}}</span>
		        </div>
		        <div style="line-height: 20px;">
		            {{$t('d.index1')}}
		        </div>
		    </div>
		    <div class="right">
		        <img src="../images/shop2/aliexpress.png">
		    </div>
		</div>

		<div class="user_money">
			<div class="border-bottom card-body">
				<div class="row">
				    <div class="col">
				        <h3 class="mb-0 font-weight-normal">
				            $ {{1*user.money}}
				        </h3>
				        <p class="text-mute">{{$t('d.balance')}}</p>
				    </div>
				    <div class="col-auto">
				        <van-icon @click="$router.push('/invest')" name="add" style="border-radius: 50px !important;" color="#fc494d" class="shadow" size="38px"/>
				    </div>
				</div>
			</div>
		    <div class="money_num">
		        <div>
					<p style="font-weight: 400; font-size: 15px; margin: 0px 5px;color: black;">
						$ {{1*user.frozenmoney}}
					</p>
					<div style="font-size: 12px;text-align: center;line-height: 30px;">
					{{$t('d.frozen')}}
					</div>
				</div>
				<div class="border-left-dotted">
					<p style="font-weight: 400; font-size: 15px; margin: 0px 5px;color: black;">
						$ {{1*user.reward}}
					</p>
					<div style="font-size: 12px;text-align: center;line-height: 30px;">
						{{$t('d.todayrewards')}}
					</div>
				</div>
		    </div>
		</div>
		<!-- <div class="index_menu" style="margin: 15px;">
		    <ul>
		       <li>
					<a href="/#/grap">
		                <div class="img">
							<van-icon name="cart"  size="25" class="icon" color="#fc494d"/>
						</div>
		                <p>{{$t('shopd.grab')}}</p>
		            </a>
		        </li>
		        <li>
		        	<a href="/#/cash">
		                <div class="img">
		        			<van-icon name="share-o"  size="25" class="icon" color="#fc494d"/>
		        		</div>
		                <p>{{$t('user.withdraw')}}</p>
		            </a>
		        </li>
				<li>
					<a href="/#/invest">
				        <div class="img">
							<van-icon name="peer-pay"  size="25" class="icon" color="#fc494d"/>
						</div>
				        <p>{{$t('moneybag.recharge')}}</p>
				    </a>
				</li>
				<li>
					<a :href="app.kefu_link" target="_blank">
				        <div class="img">
							<van-icon name="service-o"  size="25" class="icon" color="#fc494d"/>
						</div>
				        <p>{{$t('webindex.chat')}}</p>
				    </a>
				</li>
				<li>
					<a href="/#/about/26">
				        <div class="img">
							<van-icon name="descending"  size="25" class="icon" color="#fc494d"/>
						</div>
				        <p>{{$t('shopds.process')}}</p>
				    </a>
				</li>
				<li>
					<a href="/#/about/24">
				        <div class="img">
							<van-icon name="new"  size="25" class="icon" color="#fc494d"/>
						</div>
				        <p>{{$t('shopds.activity')}}</p>
				    </a>
				</li>
				<li>
					<a href="/#/about/33">
				        <div class="img">
							<van-icon name="question"  size="25" class="icon" color="#fc494d"/>
						</div>
				        <p>{{$t('webindex.commonp')}}</p>
				    </a>
				</li>
				<li>
					<a href="/#/about/34">
				        <div class="img">
							<van-icon name="info"  size="25" class="icon" color="#fc494d"/>
						</div>
				        <p>{{$t('index.aboutUs')}}</p>
				    </a>
				</li>
		    </ul>
		</div> -->
		<div class="tabsList">
		    <ul>
		        <li><a href="/#/invest">
		                <div><img src="../images/index/chognzhi.svg" alt=""></div>
		                <div>{{$t('moneybag.recharge')}}</div>
		            </a></li>
		        <li><a  href="/#/cash">
		                <div><img src="../images/index/tixian.svg" alt=""></div>
		                <div>{{$t('user.withdraw')}}</div>
		            </a></li>
		        <li><a href="/#/teamhis">
		                <div><img src="../images/index/yaoqing.svg" alt=""></div>
		                <div>{{$t('shopds.invite')}}</div>
		            </a></li>
		        <li><a href="/#/myTeam">
		                <div><img src="../images/index/tuandui.png" alt=""></div>
		                <div>{{$t('index.invite')}}</div>
		            </a></li>
		        <li><a href="/#/cashlist">
		                <div><img src="../images/index/tixian1.png" alt=""></div>
		                <div>{{$t('user.withdrawalRecord')}}</div>
		            </a></li>
		        <li><a href="/#/notice">
		                <div><img src="../images/index/huodong.png" alt=""></div>
		            </a>
		            <div>{{$t('notice.message')}}</div>
		        </li>
		    </ul>
		</div>
		<!-- <div class="grid-wrap ads_box bglight">
			<a href="javascript:void(0);" @click="$router.push('/pay')" class="grid-item">
				<van-icon name="paid"  size="25" class="icon"/>
				<span>{{$t('moneybag.recharge')}}</span>
			</a>
			<a href="javascript:void(0);" @click="$router.push('/cash')" class="grid-item">
				<van-icon name="share-o"  size="25" class="icon"/>
				<span>{{$t('moneybag.withdraw')}}</span>
			</a>
			<a href="javascript:void(0);" @click="$router.push('/transfer')" class="grid-item">
				<van-icon name="gem"  size="25" class="icon"/>
				<span>{{$t('transfer.title')}}</span>
			</a>
			<a href="javascript:void(0);" @click="$router.push('/myTeam')" class="grid-item">
				<van-icon name="friends-o"  size="25" class="icon"/>
				<span>{{$t('index.invite')}}</span>
			</a>
			
			<a href="javascript:void(0);" @click="$router.push('/vip')" class="grid-item">
				<van-icon name="fire"  size="25" class="icon"/>
				<span>{{$t('income.title2')}}</span>
			</a>
			<a href="javascript:void(0);" @click="$router.push('/item')" class="grid-item">
				<van-icon name="replay"  size="25" class="icon"/>
				<span>{{$t('income.title3')}}</span>
			</a>
		</div>	 -->	
		
	<!-- 	<div class="home_module">
			<h3>{{$t('shopds.myservices')}}</h3>
			<div class="home_nav">
				<div>
					<div class="nav_content nav1" @click="$router.push('/about/27')">
						<div>
							<img src="../images/index/guanyuwomen_1.png" draggable="true">
							<p>{{$t('index.aboutUs')}}</p>
						</div>
						<span class="uni-icons">
							 <img src="../images/user/arrow.png" > 
						</span>
					</div>
					<div class="nav_content nav2"  @click="$router.push('/download')">
						<div>
							<img src="../images/index/down.png" draggable="true">
							<p>{{$t('shopds.down')}}</p>
						</div>
						<span class="uni-icons">
							 <img src="../images/user/arrow.png" > 
						</span>
					</div>
					<div class="nav_content nav3" @click="$router.push('/about')">
						<div>
							<img src="../images/index/query.png" draggable="true">
							<p>{{$t('shopds.help')}}</p>
						</div>
						<span class="uni-icons">
							 <img src="../images/user/arrow.png" > 
						</span>
					</div>
				</div>
				<div class="uni-badge--x">
					<div class="rightAll" @click="show_kefu=true;kefu_to();">
						<div class="module_right"><p>{{$t('shopds.custhelp')}}</p></div>
						<img src="../images/index/image5.png" draggable="true">
					</div>
				</div>
			</div>
		</div> -->
	<!-- 	<div class="grid-wrap ads_box  bglight">
			<a href="javascript:void(0);" @click="$router.push('/invest')" class="grid-item">
				 <img src="../images/item/1.png" draggable="false">
				<span style="color: #8389fb;">{{$t('moneybag.recharge')}}</span>
			</a>
			<a href="javascript:void(0);" @click="$router.push('/cash')" class="grid-item">
				<img src="../images/item/2.png" draggable="false">
				<span>{{$t('moneybag.withdraw')}}</span>
			</a>
		</div> -->
		
		
		<div class="rank">
		    <div class="titList">
		        <div @click="cur=1;curlist=cashes" class="name " :class="cur==1?'actives':''">
					<img src="../images/item/1.png" alt="">
					{{$t('d.BenefitsList')}}
				</div>
		        <div @click="cur=2;curlist=cashes2" class="name " :class="cur==2?'actives':''">
					<img src="../images/item/2.png" alt="">
					{{$t('d.LatestWithdrawal')}}
				</div>
		    </div>
		</div>
		<div id="app3">
			<div class="scross" ref="scross">
				<div  v-for="(item, index) in curlist" :key="index" class="list">
				  <div class="val">
					 <div class="lef">
						 <img :src="item.img" alt="">
					 </div>
					 <div class="rig">
						 <div class="nav">{{$t('d.congratulations')}} {{item.acc}}</div>
						 <div v-if="cur==1" class="navVal">{{$t('d.Benefits')}} ${{item.money}} {{$t('d.Receipt')}}</div>
						 <div v-if="cur==2" class="navVal">{{$t('d.Withdrawal')}} ${{item.money}} {{$t('d.Receipt')}}</div>
					 </div>
				 </div>
				</div>
			</div>
		</div>
		<!-- <div v-if="app && cashes" class="ads_box" style="font-size: 16px;background-color: #ffffff;padding: 10px; display: block;box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);">
			<van-swipe style="height: 60px;" :autoplay="2000" vertical :show-indicators="false">
			  <van-swipe-item v-for="i in cashes">
				  <div  class="van-col">
						<img src="../images/home/headDefault.png" alt="">
				  </div>
				  <div class="van-col">
					  <div>{{i.acc}} {{$t('d.wsuccess')}}</div>
					  <div>{{utils_moneyMark()}} {{i.money}}</div>
				  </div>
			  </van-swipe-item>
			</van-swipe>
		</div> -->
		<!-- <div class="home_module module2">
		    <h3>{{$t('ihome.tron')}}</h3>
			<div class="business" v-if="vips">
				<template v-for="(it,i) in vips">
				<div class="vip-item" @click="$router.push('/vip')">
					<img :src="it.img" loading="lazy" alt="" class="vip-img">
				    <div class="vip-info">
				        <div class="vip-name">VIP {{it.no}}  |  {{it.rate}} %</div>
				        <div class="vip-desc">
				            <span >Deposit：</span>
				            <span style="color: #114634;font-weight: bold;">$ {{it.value}}</span>
				        </div>
				    </div>
				    <div class="action-box">
				        <van-icon v-if="vip && vip.no<it.no" name="lock" size="23" color="#fc494d"/>
						<van-icon v-else name="checked" size="23" color="#fa9832"/>
				    </div>
				    <div class="absoulte-level">{{it.name}}</div>
				   <div class="mask" v-if="vip && vip.no<it.no">
				        <div class="lock-box">
				           <van-icon name="lock" size="25" color="#fc494d"/>
				        </div>
				    </div>
				</div>
				</template>
			</div>
		</div> -->
	<!-- 	<div @click="$router.push('/teamhis')" class="between inviteItem bglight ads_box">
		    <div >
		        <div class="text_bold f44" >{{$t('shopds.invite')}}</div>
		        <div class="mt20 f20" > {{$t('shopds.earnmoremoney')}}</div>
		    </div>
		    <div >
		        <div  style="width: 148px; height: 97px;">
		            <img src="../images/user/inviteTitle.png" style="width: 148px; height: 97px;">
		        </div>
		    </div>
		</div> -->
	<!-- 	<div v-if="data && data.articles"  class="work_box">
			<div  v-for="(item, index) in data.articles" :key="index" class="item" @click="$router.push('/about/'+item.id)" style="width:33%;">
				<div class="item_img"><img :src="item.img" alt="" style="height: 90px;width: 90px;"></div>
				<div class="item_title">{{item['title_'+lang]}}</div>
			</div>
		</div> -->
		<!-- <div class="main-content" v-if="introduction">
		    <div class="main_join">
		        <div class="c_2a2a2a ft40 text-center font-bold mb30">
		            <span style="vertical-align: inherit;">
		                <span style="vertical-align: inherit;">
							{{introduction['title_'+lang]}}
		                </span>
		            </span>
		        </div>
		        <div>
		            <img src="../images/shop2/databaseAudit.png" style="width: 258px;" draggable="true">
				</div>
				<div class="c_9696a1 ft20 des">
				    <span style="vertical-align: inherit;">
				        <span style="vertical-align: inherit;" v-html="introduction['content_'+lang]">
				        </span>
				    </span>
				</div>
		    </div>
		</div> -->
		<!-- <div class="main-content"  v-if="philosophy">
		    <div class="main_join">
		        <div class="c_2a2a2a ft40 text-center font-bold mb30">
		            <span style="vertical-align: inherit;">
		                <span style="vertical-align: inherit;">
							{{philosophy['title_'+lang]}}
		                </span>
		            </span>
		        </div>
				<div>
				    <img src="../images/shop2/web.png" style="width: 258px;height: auto;" draggable="true">
				</div>
		        <div class="c_9696a1 ft20 des">
		            <span style="vertical-align: inherit;">
		                <span style="vertical-align: inherit;"  v-html="philosophy['content_'+lang]">
		                </span>
		            </span>
		        </div>
		    </div>
		</div> -->
		<!-- <div class="main-content">
			<div class="main_join"  style="margin-top: 20px;" v-if="millionaire">
			    <div class="c_2a2a2a ft40 text-center font-bold mb30">
			        <span style="vertical-align: inherit;">
			            <span style="vertical-align: inherit;">
							{{millionaire['title_'+lang]}}
			            </span>
			        </span>
			    </div>
			    <div class="c_9696a1 ft20 des">
			        <span style="vertical-align: inherit;">
			            <span style="vertical-align: inherit;"  v-html="millionaire['content_'+lang]">
			            </span>
			        </span>
			    </div>
			
			</div>
		    <div class="main_about" style="margin-top: 20px;"  v-if="about">
		        <div class="about">
		            <div class="title">
						<span style="vertical-align: inherit;">
							<span style="vertical-align: inherit;">{{about['title_'+lang]}}</span>
						</span>
		            </div>
		            <div>
		                <span>
		                    <span style="vertical-align: inherit;">
		                        <span style="vertical-align: inherit;">
									{{$t('webindex.webest')}}
								</span>
		                    </span>
		                </span>
		            </div>
		            <div class="content">
		                <span style="vertical-align: inherit;"  v-html="about['content_'+lang]">
		                </span>
		            </div>
		            <div>
		                <div style="background-image: url('../images/index/about.png'); background-position: 0% 0%; background-size: 100% 100%; background-repeat: no-repeat;"></div>
		                <img src="../images/index/about.png" draggable="true">
		            </div>
		        </div>
		    </div>
			
			<div class="main_display">
			    <div class="h3">
			        <span style="vertical-align: inherit;">
			            <span style="vertical-align: inherit;">{{$t('webindex.platform')}}</span>
			        </span>
			    </div>
			    <div class="box flex-between">
			        <div class="item">
			            <div>
			                <div style="background-image: url('../images/index/profit.png'); background-position: 0% 0%; background-size: 100% 100%; background-repeat: no-repeat;"></div>
			                <img src="../images/index/profit.png" draggable="true"></div>
			            <div>
			                <span>
			                    <span style="vertical-align: inherit;">
			                        <span style="vertical-align: inherit;">{{$t('webindex.accumulated')}}</span>
			                    </span>
			                </span>
			            </div>
			            <div>
			                <span style="vertical-align: inherit;">
			                    <span style="vertical-align: inherit;">{{data.paynum}}</span>
							</span>
			            </div>
						<div>({{utils_moneyMark()}})</div>
			        </div>
			        <div class="item">
			            <div>
			                <div style="background-image: url('../images/index/member.png'); background-position: 0% 0%; background-size: 100% 100%; background-repeat: no-repeat;"></div>
			                <img src="../images/index/member.png" draggable="true"></div>
			            <div>
			                <span>
			                    <span style="vertical-align: inherit;">
			                        <span  style="vertical-align: inherit;">{{$t('webindex.members')}}</span>
			                    </span>
			                </span>
			            </div>
			            <div>
			                <span style="vertical-align: inherit;">
			                    <span style="vertical-align: inherit;">{{data.huinum}}</span>
			                </span>
			            </div>
			        </div>
			    </div>
			</div>
		</div> -->
	
	<!-- 	<div class="ads_box" style="font-size: 16px;background-color: #ffffff;padding: 10px; display: block;">
			<div class="items_tit" style="width: 100%;font-weight: bold;">
				{{$t('ihome.tron')}}
			</div>
			<div class="business" v-if="vips && app">
				<div class="vip-item"  v-for="(it,i) in vips" :key="i" @click="upvip(it)" v-if="!data.vip || parseFloat(data.vip.rate)<=parseFloat(it.rate)">
					<img :src="app.logo_img" loading="lazy" alt="" class="vip-img">
				    <div class="vip-info">
				        <div class="vip-name">Commission：{{it.rate}} %</div>
				        <div class="vip-desc">
				            <div>Required Recharge：</div>
				            <div class="text-bold text-df" style="color: #fc494d;">{{it.value}} USDT </div>
				        </div>
				    </div>
				    <div class="action-box">
						<div class="ord">Order</div>
				        <div class="i-icon ">
							{{it.onum}}
				        </div>
				    </div>
				    <div class="absoulte-level">VIP{{i}}</div>
				    <div class="mask" v-if="!data.vip || parseFloat(data.vip.rate)<parseFloat(it.rate)">
				        <div class="lock-box">
				           <van-icon name="lock" size="25" color="#fff"/>
				        </div>
				    </div>
				</div>
			</div>
		</div> -->
		
		<!-- <div class="ads_box" style="font-size: 16px;background-color: #ffffff;padding: 10px; display: block;">
			<div class="items_tit" style="width: 100%;font-weight: bold;">
				{{$t('ihome.tixian')}}
			</div>
			<div class="notice_content" style="height: 180px;">
			    <div class="notice_list">
			        <div class="notice_item">
			            <div class="name gray">{{$t('ihome.acc')}}</div>
			            <div class="value gray">{{$t('ihome.ti')}}</div>
			        </div>
			    </div>
				<marquee width="100%" height="150px" scrollamount="2" loop='infinite' behavior="alternate" direction="up">
			    <ul class="notice_list" v-if="cashes">
			        <li class="notice_item" v-for="i in cashes">
			            <div class="name">{{i.acc}}</div>
			            <div class="value">{{i.money}} {{utils_moneyMark()}}</div>
			        </li>
					<li class="notice_item" v-for="i in cashes">
					    <div class="name">{{i.acc}}</div>
					    <div class="value">{{i.money}} {{utils_moneyMark()}}</div>
					</li>
					<li class="notice_item" v-for="i in cashes">
					    <div class="name">{{i.acc}}</div>
					    <div class="value">{{i.money}} {{utils_moneyMark()}}</div>
					</li>
					<li class="notice_item" v-for="i in cashes">
					    <div class="name">{{i.acc}}</div>
					    <div class="value">{{i.money}} {{utils_moneyMark()}}</div>
					</li>
					<li class="notice_item" v-for="i in cashes">
					    <div class="name">{{i.acc}}</div>
					    <div class="value">{{i.money}} {{utils_moneyMark()}}</div>
					</li>
					
			    </ul>
				</marquee>
			</div>
		</div> -->
	<!-- 	<div class="home_module module2">
		   <h3>{{$t('item.partner')}}</h3>
			<div>
				<img src="../images/shop2/brandicon.png" draggable="true" style="border-radius: 5px;width: 100%;">
			</div>
		   <div class="module2_content">
				<a  v-for="ad in data.ad4" :href="ad['url']">
					<img  :src="ad[lang]" >
				</a>
		    </div>
		</div> -->
 		<!-- <div class="ads_box shadow" style="font-size: 16px;height: 40px;background-color: #ffffff;padding-top: 10px; padding-left: 10px;">
			<div class="items_tit" style="width: 100%;font-weight: bold;">
				{{$t('item.partner')}}
			</div>			
		</div>
		<div class="ads_box shadow" style="background-color: #ffffff;flex-wrap: wrap;">			
			<div class="ads_img" v-for="ad in data.ad4" style="overflow:hidden;width:22%;min-height: 50px;float: left;margin-left: 5%;margin-right: 5%;margin-top:15px;">
				<a target="_blank" :href= "ad.url" style="width:100%;">
					<img style="width:100%;" :src="ad[lang]" alt="">
				</a>
			</div>
		</div> -->
		<van-popup 
		v-model="show"
		round 
		:style="{ 'line-height': '30px',
			'width': '70%',
			'padding': '15px',
			'font-weight': 'bold'}"
		>{{msg}}</van-popup>
		<van-dialog
			 width="90%"
			v-model="show_tc"
			:confirmButtonText="$t('utils.confirm')">
			<img width="100%" src="../images/index/tanchuang.png">
			<div class="popup" v-html="tc_content"></div>
		</van-dialog>

	<!-- 	<div v-if="msg_show" class="kefu" :class="show_kefu?'':'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" src="../images/shop2/kefu.jpg">
		</div> -->
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	import { NoticeBar } from 'vant';
	Vue.use(NoticeBar);
	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Popup,
		Dialog,
		Field
	} from "vant";
	Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Popup);
	export default {
		name: "Index",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_kefu: false,
				msg_show: true,
				loading: false,
				icon: [],
				user:{},
				data: {item1:{show:true},item2:{show:true},item3:{show:true}},
				app:{},
				islogin:false,
				isapp:false,
				show_img: false,
				show_tz:false,
				show_tc:false,
				tc_content:"",
				number: '',
				vips:null,
				vip:null,
				about:null,
				acc:null,
				msg:null,
				show:false,
				millionaire:null,
				philosophy:null,
				introduction:null,
				sku:[],
				banner:null,
				articlessun:null,
				cur:1,
				cashes:null,
				cashes2:null,
				curlist:null,
				timer:null,
				len: 0,
				intervalId: null,
				coindatas:null,
				notifyStr:''
			};
		},
		created() {
			this.$parent.footer('index');
		},
		// beforeDestroy() {
		//     clearInterval(this.timer);
		// },
		mounted() {
			this.start();
			// this.accinfo();
			this.$nextTick(() => {
				setTimeout(() => {
				  this.startAnimation();
				},200);
			});
			
		//	this.audioTitleScroll();
			//代理标识设置
			if(this.$router.history.current.query.agent){
				localStorage.setItem('agent', this.$router.history.current.query.agent);
			}
			//APP识别
			if(this.$router.history.current.query.isapp){
				localStorage.setItem('isapp', 'true');
			}
			this.isapp = localStorage.getItem('isapp')!=null;
			
			var that = this;
			document.body.addEventListener("scroll", function() {
				if (!that.show_kefu) {
					return;
				}
				that.show_kefu = false;
			}, false);
			document.addEventListener('click', function(ev) {
				if (ev.target.className != 'kefu_img') {
					that.show_kefu = false;
				}
			}, false);
		},
		beforeDestroy() {
			clearInterval(this.intervalId); // 组件销毁前清除定时器
		},
		methods: {
			startAnimation() {
			  this.intervalId = setInterval(() => {
				// 计算滚动距离
				const scrossElement = this.$refs.scross;
				scrossElement.style.transition = 'top 2s';
				scrossElement.style.top = this.len * -92 + 'px';
				
				// 动画结束后进行克隆和追加
				setTimeout(() => {
				  this.len++;
				  const randomIndex = Math.floor(Math.random() * this.curlist.length);
				  const newItem = this.curlist[randomIndex];
				  this.curlist.push(newItem); // 添加新项
				}, 2000);
			  }, 2000);
			},
			upvip(it){
				this.$router.push('/invest');
				// if(this.vip){
				// 	if(this.vip.no < it.no){
				// 		Dialog.confirm({
				// 			title: this.$t('shopd.suretitle'),
				// 			confirmButtonText: this.$t('shopd.surebtn'),
				// 			cancelButtonText: this.$t('shopd.cancelbtn'),
				// 			message: this.$t('shopd.surec1')+it.price+ this.$t('shopd.surec2')+it.no+'?'
				// 		}).then(() => {
				// 		    Fetch('/user/upvip', {
				// 		      vip: it.id
				// 		    }).then((r) => {
				// 				if(r.code==1){
				// 					this.$router.push('/user');
				// 				}else{
				// 					this.$router.push('/invest');
				// 				}
								
				// 		    });
				// 		}).catch(() => {
						    
				// 		});
				// 	}
				// }else{
				// 	this.$router.push('/invest');
				// }
			},
			// accinfo() {
			// 	Fetch('/user/info').then((r) => {
			// 		this.acc = r.data;
			// 		this.vips= r.data.vips;
			// 		this.vip = r.data.vip;
			// 	});
			// },
			download(){
				let downloadurl = document.createElement('A');
				downloadurl.href = this.app.app_link;
				downloadurl.target = "blank";
				downloadurl.click();
			},
			kefu_to() {
				if (this.show_kefu) {
					var user = this.acc.user;
					var link = this.app.kefu_link + '&uid='+user.id+ '&name='+user.phone;
					// window.location.href = link;
					this.$router.push('/kefu');
				}
				this.show_kefu = !this.show_kefu;
			},
			hideDown() {
				this.show_img = false;
				this.$store.commit('setShowAdvert', false);
			},
			start() {
				Fetch('/user/info').then((r) => {
					this.user = r.data;
				});
				Fetch('/index/int').then((r) => {
					this.data = r.data;
					
					this.banner = r.data.banner;
					this.cashes = r.data.cashes;
					this.cashes2 = r.data.cashes2;
					this.curlist = this.cashes;
					this.articlessun = r.data.articlessun;
					var articles = r.data.articles;
				
					this.loading = true;
					if(r.data.popup.show==1){
						this.tc_content = r.data.popup.content;
						if(localStorage.getItem('tc')!=this.tc_content){
							localStorage.setItem('tc',this.tc_content);
							this.show_tc = true;
						}
					}
				});
				Fetch('/user/basicinfo').then((r) => {
					this.acc = r.data;
					this.vip = r.data.vip;
					this.vips = r.data.vips;
				});
				Fetch('/index/webconfig').then((r)=>{
					this.app = r.data;
					this.notifyStr = this.app.notice;
				});
				this.islogin = localStorage.getItem('token')!=null;
				setTimeout(()=>{
					this.sync();
				},2000)
			},
			onChange(index) {
				let els = this.$refs.dian.querySelectorAll("div");
				for (let i = 0; i < els.length; i++) {
					els[i].className = "";
				}
				els[index].className = "selected";
			},
			sync() {
				Fetch("/index/sync", {}, null, false).then((r) => {
					var data = r.data;
					if(data && data.length>0){
						this.msg = data[0].content;
						this.show= true;
						setTimeout(()=>{
						  Fetch('/user/notice_view', {
						  	id: data[0].id
						  }).then(res => {
						  })
						},2000);
					}
				});
			},
			buy(item){
				this.sku = item;
				this.show_tz = true;
			},
			confirm(){
				Fetch("/index/item_apply", {
				  id: this.sku.id,
				  money:this.number
				}).then(r => {
					if (r.data && r.data>0) {
						this.$router.push("/invest/trx/"+r.data);
					} else {
						this.$router.push("/order");
					}
				}).catch(err=>{
				    this.psd_val = '';
				})
			},
		   audioTitleScroll() { 
				var audio_title = $(".wrap");
				audio_title.each(function() {
					titleScroll(this);
				});

				function titleScroll(wrap) {
					var div = wrap.getElementsByTagName('div')[0];
					var span = div.getElementsByTagName('span')[0];
					var span_w = 1000;
					if (span) {
						span_w = span.offsetWidth;
					}
					var div_w = wrap.offsetWidth;
					if (div_w > span_w || div.getElementsByTagName('span').length >= 2) {
						// console.log(777);
						return false;
					}
					// console.log(666);
					div.innerHTML += div.innerHTML;
					var timer = setInterval(goLeft, 20);
					$(wrap).hover(function() {
						clearInterval(timer);
					}, function() {
						timer = setInterval(goLeft, 20);
					});

					function goLeft() {
						if (span_w <= wrap.scrollLeft) {
							wrap.scrollLeft -= span_w;
						} else {
							wrap.scrollLeft++;
						}
					}
				}
			}
		}
	};
</script>
<style lang="less" scoped>
	/deep/ .van-cell{
		padding: 15px 26px;
	}
	.home_wrap {
		width: 100%;
		padding-bottom: 60px;
	}
	.red_top_bg{
		.language{
			position: absolute;
			top: 4px;
			left: 5px;
			height: 36px;
			img{
				height: 100%;
				border-radius: 50%;
				box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
			}
		}
		.msg{
			position: absolute;
			top: 5px;
			right: 45px;
			height: 30px;
			
			img{
				height: 100%;
			}
		}
		.service{
			position: absolute;
			top: 5px;
			right: 6px;
			height: 30px;
			img{
				height: 100%;
			}
		}
		.top_title{
			text-align: center;
			font-size: 24px;
			display: block;
			height: 44px;
			line-height: 44px;
		}
	}
	.langbar {
		position: relative;
	    margin-top: 44px;
		padding-top: 8px;
		height: 56px;
		background-color: #fff;

	}
    .search_box {
        width: 90%;
        height: 32px;
        background-color: #f6f6f6;
        border-radius: 17px;
		border: solid 1px #1989fa;
        margin: 8px auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px 0 14px;

        .fdj {
            width: 16px;
            height: 16px;
            background: url(../images/item/fdj.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .search_inp {
            flex: 1;
            margin: 0 8px;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            height: 20px;
        }

        .clear_inp {
            width: 20px;
            height: 20px;
            background: url(../images/item/clear.png) no-repeat center center;
            background-size: 100% 100%;
        }
    }

	.swiper-container {
		width: 100%;
		height: 120px;
		background: none;
		margin-top: 5px;
		.van-swipe-item {
			overflow: hidden;
		}

		a {
			float: left;
			width: 100%;
			height: 100%;
		}

		img {
			border-radius: 6px;
			margin-left: 2%;
			height: 100%;
			width: 96%;
		}
	}
	.work_box {
		background: #FFFFFF;
		padding: 17px 8px 4px 8px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		border-radius: 16px;
    	margin: 8px 8px;
		.item {
			width: 25%;
			text-align: center;
			margin-bottom: 10px;
			.item_img {
				width: 100%;
				border-radius: 5px;
				overflow: hidden;
				img {
					width: 44px;
					height: 44px;
				}
			}

			.item_title {
				width: 100%;
				line-height: 14px;
				font-size: 12px;
				color: #333333;
				text-align: center;
				transform: scale(0.85);
			}
		}
	}

	.work_box.query {
		.item {

			.item_img {
				border-radius: 5px;
				background: #f0f0f0;
			}

			.item_title {
				width: 100%;
				height: 14px;
				margin-left: 0;
				background: #f0f0f0;
			}
		}

	}
	.ads_box_1{
		border-radius: 13px;
		margin-top: 10px;
		text-align: center;
		img{
			width: 95%;
		}
	}
	.ads_box{
		// background: rgba(255, 255, 255, 1);
		width: 92%;
		border-radius: 5px;
		margin:5px auto 0 auto;
		display: flex;
		text-align: center;
		.ads_img{

		}
		img{
			width: 96%;
			border-radius: 5px;
		}
	}
	.items_1,
	.items_2,
	.items_3
	{
		margin: 10px 2% 0 2%;
		width: 96%;
		.items_tit {
      overflow: hidden;
			border-radius: 5px 5px 0 0 ;
			height: 44px;
			line-height: 44px;
			font-size: 16px;
			color: rgba(0, 0, 0, .8);
			background: #FFFFFF;
			border-bottom: 1px solid #F7F7F7;
			padding: 0 14px;
			display: flex;
			justify-content: space-between;
			.tit_tip{
				display: contents;
				font-size: 12px;
				font-weight: normal;
				color: #b2b2b2;
				margin-left: 10px;
			}
			.tit_more{
				font-size: 12px;
				font-weight: normal;
				color: #b2b2b2;

			}
		}
		.item{
			background: #FFFFFF;
		}
	}
	.items_1 {
		.item{
			padding: 5px;
			margin: 0 0 10px 0;
			div{
				margin: 20px 0;
			}
			.item_tit{
				text-align: center;
				overflow: hidden;
				p{
					text-overflow:ellipsis;
					white-space: nowrap;
					font-weight: bold;
					font-size: 16px;
				}
			}
			.item_rate{
				text-align: center;
				color: #FF0000;
				font-size: 22px;
				font-weight: bold;
			}
			.item_desc{
				p{
					width: 50%;
					text-align: center;
				}
			}
			.item_btn{
				text-align: center;

				button{
					margin: auto;
					width: 60%;
					min-width: 60px;
					background: #e7544d;
					color: #FFFFFF;
					padding: 10px 0px;
					border-radius: 10px;
				}
				.item_btn_over{
					background: #999;
				}
			}
		}
	}
	.items_2 {
		.item{
			display: flex;
			width: 100%;
			text-align: center;
			border-bottom: 1px solid #ECECEC;
			div{
				margin: 15px 0;
			}
			.item_rate{
				width: 20%;
				p{
					padding: 5px 0;
				}
				p:nth-child(1){
					font-weight: bold;
					font-size: 14px;
					color: #FF0000;

				}
				p:nth-child(2){
					color: #999;
					font-size: 12px;
				}
			}
			.item_tit{
				width: 55%;
				p{
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;
					padding: 5px 0;
				}
				p:nth-child(1){
					font-weight: bold;
				}
				p:nth-child(2){
					color: #999;
					font-size: 12px;
				}
			}
			.item_btn{
				width: 25%;
				button{
					min-width: 60px;
					margin-top: 12px;
					color: #1989fa;
					padding: 5px 5px;
					border-radius: 5px;
					border: 1px solid #1989fa;
				}
				.item_btn_over{
					color: #999;
					border: 1px solid #999;
				}
			}
		}
	}
	.items_3 {
		.item{
			margin-bottom: 10px;
			div{
				margin: 5px 0;
			}
			.item_div1{
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid #ECECEC;
				padding: 15px 10px;
				p:nth-child(1){
					// width: 70%;
					font-weight: bold;
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;

				}
				p:nth-child(2){
					color: green;
					font-size: 12px;
				}
			}
			.item_div2{
				display: flex;
				justify-content: space-between;
				text-align:center;
				font-size: 14px;
				div{
					width: 33.33%;
					p{
						padding: 5px 0;
					}
				}
				.item_rate{
					p:nth-child(1){
						font-weight: bold;
						color: red;
					}
					p:nth-child(2){
						color: green;
						font-size: 12px;
					}
				}
				.item_day{
					p:nth-child(1){
						font-weight: bold;
					}
					p:nth-child(2){
						color: green;
						font-size: 12px;
					}
				}
				.item_min{
					p:nth-child(1){
						font-weight: bold;
						color: red;
					}
					p:nth-child(2){
						color: green;
						font-size: 12px;
					}
				}
			}
			.item_div3{
				color: #999;
				padding: 5px 10px;
			}
			.item_div4{
				padding: 5px 10px;
				display: flex;
				justify-content: space-between;
				div:nth-child(1){
					width: 75%;
					margin-top: 16px;
				}
				.item_btn{
					width: 20%;
					button{
						min-width: 60px;
						color: #1989fa;
						padding: 5px 5px;
						border-radius: 5px;
						border: 1px solid #1989fa;
					}
					.item_btn_over{
						color: #999;
						border: 1px solid #999;
					}
				}
			}
		}
	}
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 60vh;
		padding: 15px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}

	.wrap {
		padding-top: 10px;
		overflow: hidden;
		width: 150px;
		cursor: pointer;
	}

	.scroll {
		width: 1200px;
		height: 30px;
		line-height: 30px;
		overflow: hidden;
	}
			
	.items_1 .item div.item_desc{
		color: #bec3ce;
		font-size: 12px;
		margin: 10px;
	}
	.notice-swipe {
		height: 40px;
		line-height: 40px;
	}
	.items_1 .item .item_btn button{
	    border-radius: 5px;
	}
	.main_problem{
		overflow: hidden;
		margin-bottom: 0px;
		padding: 10px;
		background-color: #FFFF;
		padding-bottom: 0px;
	}
	.alcenter {
	    align-items: center;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.font-bold {
	    font-weight: 700;
	}
	.ft26 {
	    font-size: 13px;
	}
	.mb10 {
	    margin-bottom: 5px;
	}
	.c_2a2a2a {
	    color: #2a2a2a;
	}
	.ft20 {
	    font-size: 10px!important;
	}
	.main_problem img{
	    width: 60px;
	    height: 60px;
		display: inline-block;
		overflow: hidden;
		position: relative;
	}
	.main-content{
	    overflow: hidden;
	    width: 100%;
	    background: none;
	    padding: 10px 8px;
	    box-sizing: border-box;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.main-content .link_box .label{
	    width: 48%;
	    height: 180px;
	    background-color: #fff;
	    border-radius: 10px;
	    box-shadow: 0 10px 20px 0 rgb(185 212 205 / 25%);
	    padding-top: 18px;
	    box-sizing: border-box;
	}
	.main-content .link_box .label>div:nth-child(1){
		display: block;
		width: 87px;
		height: 66px;
		margin: 0 auto 5px;
		overflow: hidden;
		position: relative;
		div{
			width: 100%;
			height: 100%;
		}
		img{
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}
	.flex-center {
		justify-content: center;
		align-items: center;
		text-align: center;
		margin-top: 25px;
		line-height: 20px;
	}
	.font-bold {
	    font-weight: 700;
	}
	.ft36 {
	    font-size: 18px;
	}
	.c_48a093 {
	    color: #48a093;
	}
	.ml10 {
	    margin-left: 5px;
	}
	.c_2a2a2a {
	    color: #2a2a2a;
	}
	.main_join{
	    overflow: hidden;
	    width: 100%;
	    background-color: #fff;
	    padding: 22px 17px 28px;
	    text-align: center;
	    box-sizing: border-box;
		border-radius: 5px;
		.btn{
		    width: 159px;
		    height: 34px;
		    border-radius: 20px;
		    font-size: 16px;
		    font-weight: 700;
		    color: #fff;
		    background: linear-gradient(270deg,#4caa8e,#5bc878);
		    margin: 16px auto 0;
		    overflow: hidden;
		}
		.flex-center {
		    display: flex;
		    justify-content: center;
		    align-items: center;
		}
		img{
			width: 258px;
		}
		div:nth-child(3){
			height: auto;
			margin: 15px auto 0;
			img{
				width: 100%;
			}
		}
	}
	.ft40 {
	    font-size: 20px;
	}
	.text-center {
	    text-align: center;
	}
	.mb30 {
	    margin-bottom: 15px;
	}
	.main_join .des{
	    text-align: left;
	    margin: 0 auto;
	    line-height: 18px;
	}
	.ft20 {
	    font-size: 10px!important;
	}
	.c_9696a1 {
	    color: #9696a1;
	}
	.main_display{
	    margin-top: 35px;
	    overflow: hidden;
		.h3{
		    font-size: 20px;
		    font-weight: 700;
		    color:#FFFFFF;
		    text-align: center;
		    margin-bottom: 20px;
		}
		#box{
		    width: 100%;
		    margin-top: 54px;
			.item{
			    position: relative;
			    width: 48%;
			    height: 136px;
			    background-color: #fff;
			    border-radius: 10px;
			    padding-top: 59px;
			    box-shadow: 0 10px 20px 0 rgb(185 212 205 / 25%);
			    box-sizing: border-box;
				div:nth-child(1){
				    width: 75px;
				    height: 75px;
				    position: absolute;
				    left: 30%;
				    top: -33px;
					img{
						height: 100%;
					}
				}
				div:nth-child(2),div:nth-child(4){
					display: block;
					text-align: center;
					font-size: 12px;
					line-height: 1.1;
					color: #2a2a2a;
					margin-bottom: 10px;
				}
				div:nth-child(3){
					text-align: center;
					font-size: 20px;
					color: #02a393;
					line-height: 20px;
					font-weight: 600;
					margin-bottom: 10px;
				}
			}
		}
	}
	.main_about{
	    width: 100%;
	    overflow: hidden;
	    background-color: #fff;
	    border-radius: 10px;
	    margin-top: 28px;
	    padding: 21px 0 54px;
	    box-sizing: border-box;
		.about {
			.title{
			    text-align: center;
			    font-size: 20px;
			    font-weight: 700;
			    margin-bottom: 14px;
			    color: #2a2a2a;
			}
			div:nth-child(2){
				display: block;
				text-align: center;
				font-size: 16px;
				color: #2a2a2a;
				margin-bottom: 18px;
			}
			.content{
			    padding: 0 34px;
			    font-size: 10px;
			    color: #9696a1;
			    line-height: 16px;
			}
			div:nth-child(4){
				display: block;
				width: 280px;
				height: 164px;
				margin: 35px auto 0;
				img{
					height: 100%;
				}
			}
		}
	}
	.banner {
	   height: 52px;
	   display: flex;
	   width: 100%;
	   background: none;
	   background-size: 100% 100%;
	   position: relative;
	   flex-direction: column;
		p {
		    padding: 67px 0 0 52px;
		    font-size: 15px;
		    color: #b4ffec;
		    font-weight: 500;
		}
		>div {
		    padding: 10px 0 0 52px;
			color: #fff;
			font-size: 24px;
			font-weight: 700;
			position: relative;
			display: flex;
			z-index: 2;
			align-items: center;
			>span {
			    font-size: 16px;
			    margin-left: 5px;
			}
		}
		.notice {
			height: 52px;
			padding: 0;
			font-size: 14px;
			font-weight: 400;
			display: block;
			width: 100%;
			// background: linear-gradient(270deg, #f90, #746b0a);
			.icon {
			    width: 45px;
			    height: 45px;
			    line-height: 48px;
			    text-align: center;
			    position: absolute;
			    left: 0;
			    top: 1px;
				img {
				    width: 40px;
				    position: absolute;
				    top: 8px;
				    left: 8px;
				}
			}
			.text {
			    position: absolute;
			    left: 48px;
			    top: 1px;
			    right: 0;
			    line-height: 48px;
			}
		}
	}
	.tabs {
	    display: flex;
	    padding-top: 14px;
	    flex-direction: column;
		>ul {
		    list-style: none;
		    margin: 0;
		    padding: 0;
		    text-align: center;
			>li {
			    width: 33.33333%;
			    float: left;
			    background: none;
			    padding-bottom: 10px;
				>img {
				    width: 75%;
				    height: 75%;
				    margin: auto;
					height: 68px;
				}
				>p {
				    font-weight: 600;
				    font-size: 13px;
				    padding-top: 5px;
				    color: #fff;
				}
			}
		}
	}
	
	.game-list{
		.game-item {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    height: 50px;
		}
		.icon {
		    margin-right:10px;
		    width: 23px;
		    height: 23px;
		    border-radius: 100%;
		    overflow: hidden;
			img {
			    display: block;
			    width: 100%;
			    height: 100%;
			}
		}
		.title {
		    display: block;
		    font-size: 14px;
		}
		.info {
		    width: 119px;
		    line-height: 1;
		    text-align: left;
		}
		.time {
		    color: #ababab;
			font-size: 12px;
		}
		.price.mine-rise {
		    color: #17cdaf;
		}
		.price.mine-fall {
		    color: #f85963;
		}
		.price {
		    flex: 1;
		    font-size: 16px;
		    font-weight: 700;
		    text-align: right;
		    padding-right: 10px;
		}
		 .zd.mine-rise {
		    background: #17cdaf;
		}
		.zd {
		    display: block;
		    width: 79px;
		    height:27px;
		    background-color: #f85963;
		    border-radius: 5px;
		    line-height: 27px;
		    text-align: center;
		    font-size:14px;
		    color: #fff;
		}
	} 
	.notice_content{
		overflow: hidden;
		transition: top .5s;
		.notice_list {
			padding: 0;
		}
		.notice_item {
		    display: flex;
		    justify-content: space-between;
		    font-size: 14px;
		    height: 30px;
		    line-height: 30px;
			div{
			}
		}
		.gray {
			font-size: 12px;
			color: #ababab;
		}
	}
	.swiper-wrapper {
	    position: relative;
	    width: 100%;
	    height: 100%;
	    z-index: 1;
	    display: flex;
	    transition-property: transform;
	    box-sizing: content-box;
		.swiper-slide {
		    flex-shrink: 0;
		    width: 100%;
		    height: 100%;
		    position: relative;
		    transition-property: transform;
		}
		.van-swipe-item {
		    display: flex;
		}
		.item-left {
		    margin-right: 20px;
			img {
				overflow: hidden;
				width: 60px;
				height: 60px;
				border-radius: 100%;
				border: 5px solid #eee;
			}
		}
		.item-body {
		    flex: 1;
			text-align: left;
			line-height: 16px;
			color: #8a9089;
		}
		.people-content {
		    margin:5px 0 10px;
		    color: #8a9089;
		    font-size: 12px;
		}
		.people-name {
			font-size: 14px;
			color: #656b64;
			font-weight: 700;
		}
	}
	.ads_box{
		.items_tit{
			margin-bottom: 25px;
		}
	}
	
	
	.vip-item {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	    -webkit-justify-content: space-between;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    padding: 2vw 3vw;
	    box-sizing: border-box;
	    border-radius: 8px;
	    background-color: #fff;
	    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	    margin-bottom: 12px;
	    position: relative;
	    overflow: hidden;
	}
	.vip-item .vip-img {
	    width: 20vw;
	    height: 20vw;
	}
	.vip-item .vip-info {
	    text-align: left;
		width: 50%;
	}
	.vip-item .vip-info .vip-name {
	    font-size: 3.8vw;
	    color: #222;
		margin-bottom: 1vw;
		margin-top: 5%;
	}
	.vip-item .vip-info .vip-desc {
		font-size: 12px;
		color: #999;
		line-height: 1.5em;
	}
	.vip-item .action-box .ord{
		font-size: 2vw;
		font-weight: bold;
		line-height: 6vw;
		color: rgb(74, 193, 171);
	}
	.vip-item .action-box .i-icon {
	    padding: 2vw 3vw;
	    text-align: center;
	    background-color: #fc494d;
	    font-size: 14px;
	    color:#fff;
	    border-radius: 1.5em;
	    cursor: pointer;
	}
	
	.vip-item .absoulte-level {
	    position: absolute;
	    background: #f5f5f5;
	    color: #fc494d;
	    padding: 24px 16px 8px 16px;
	    border-radius: 50%;
	    top: -20px;
	    left: 40%;
	    font-size: 12px;
	}
	.vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	.vip-item .mask {
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,.4);
	    border-radius: 8px;
	    z-index: 2;
	}
	
	.vip-item .mask .lock-box,.index-wrap2 .vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	
	.vip-item .mask .lock-box {
	    background: hsla(0,0%,100%,.4);
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	}
	.vip-item .mask .lock-box, .index-wrap2 .vip-item .mask{
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}
	 .my-swipe .van-swipe-item {
	    
	  }
	  .item_title{
	  	font-size: 1.3em;
	  	font-weight: bold;
	  	line-height: 6vw;
	  	margin-top: 2vw;
	  }
	.bannerswip{
		width: 90%;
		height: auto;
		margin:5px 5%;
		border-radius: 10px;
		img{
			border-radius: 10px;
		}
	}
	.home_earnings{
	    width: 90%;
	    height: 41px;
	    margin: 3% 5%;
	    border-radius: 10px;
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    padding: 0 10px;
	    background-color: #fc494d;
	    font-size: 15px;
		div{
			min-width: 40%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	.notice_content{
		width: 90%;
		margin: 2% 5%;
		height: 36px;
		background-color: #fc494d;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 5px;
		.name{
			width: 50vw;
			display: block;
		}
		.value{
			width: 50vw;
			display: block;
		}
	}
	.home_module{
	    width: 90%;
	    margin: 0 5%;
	    color: #232f3e;
		h3{
		    height: 30px;
			display: block;
			font-size: 18px;
			margin-block-start: 1em;
			margin-block-end: 1em;
			margin-inline-start: 0px;
			margin-inline-end: 0px;
			font-weight: bold;
			margin-bottom: 0;
		}
		.module2_content{
		    width: 100%;
			padding-bottom: 100px;
		    display: flex;
		    justify-content: space-between;
		    flex-wrap: wrap;
		    align-items: center;
			img{
				height: 100%;
				border-radius: 10px;
				margin: 2% 0;
			}
			a{
				height: 68px;
				border-radius: 10px;
				margin: 2% 0;
			}
		}
		.home_nav{
		    width: 100%;
		    height: 140px;
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    font-size: 15px;
			>div:first-child {
			    width: 48%;
			    height: 100%;
			    display: flex;
			    flex-direction: column;
			    align-items: center;
			    justify-content: space-between;
				.nav1{
				    background-color: #f4e1ff;
				}
				.nav2{
				    background-color: #ffd9e7;
				}
				.nav3{
				    background-color: #feeba9;
				}
				.nav_content{
				    width: 100%;
				    height: 30%;
				    display: flex;
				    justify-content: space-between;
				    align-items: center;
				    border-radius: 5px;
				    padding: 5px;
					>div:first-child {
					    width: 70%;
					    display: flex;
					    align-items: center;
					}
					.uniui-forward:before {
					    content: "\e660";
					}
					.uni-icons {
					    font-family: uniicons;
					    text-decoration: none;
					    text-align: center;
						img{
							height: 18px;
							width: 18px;
						}
					}
					img{
					    width: 26px;
					    height: 26px;
					}
					p{
					    margin-left: 3%;
					}
				}
			}
			>div:last-child {
				width: 48%;
				height: 100%;
				display: flex;
				border-radius: 5px;
				flex-direction: column;
				align-items: center;
				justify-content: space-between;
				background-color: #c3cdff;
				.rightAll{
				    position: relative;
				    box-sizing: border-box;
				    width: 100%;
				    height: 100%;
					.module_right{
					    width: 100%;
					    padding: 0 5px;
					    display: flex;
					    justify-content: space-between;
					    align-items: center;
					    margin: 3% 0;
					}
					img{
					    width: 100%;
					    height: 70%;
					}
				}
			}
		}
	}
	
	.vip-item {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	    -webkit-justify-content: space-between;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    padding: 12px 16px;
	    box-sizing: border-box;
	    border-radius: 8px;
	    background-color: #fff;
	    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	    margin-bottom: 12px;
	    position: relative;
	    overflow: hidden;
	}
	.vip-item .vip-img {
	    width: 50px;
	    height: 50px;
	}
	.vip-item .vip-info {
	    text-align: left;
		width: 45%;
		max-width: 200px;
	}
	.vip-item .vip-info .vip-name {
	    font-size: 13px;
	    color: #fc494d;
	    margin-bottom: 12px;
	}
	.vip-item .vip-info .vip-desc {
	    font-size: 12px;
	    color: #999;
	}
	
	.vip-item .action-box {
	    padding: 6px 16px 4px 16px;
	    text-align: center;
	    font-size: 14px;
	    border-radius: 40px;
	    cursor: pointer;
	}
	
	.vip-item .absoulte-level {
	    position: absolute;
	    background: #f5f5f5;
	    color: #fc494d;
	    padding: 24px 16px 8px 16px;
	    border-radius: 30%;
	    top: -20px;
	    left: 40%;
	    font-size: 12px;
	}
	.vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	.vip-item .mask {
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,.4);
	    border-radius: 8px;
	    z-index: 2;
	}
	
	.vip-item .mask .lock-box,.index-wrap2 .vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	
	.vip-item .mask .lock-box {
	    background: hsla(0,0%,100%,.4);
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	}
	.vip-item .mask .lock-box, .index-wrap2 .vip-item .mask{
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}
	.grid-wrap {
	    display: flex;
		grid-template-columns: repeat(3,1fr);
		font-size: 14px;
		text-align: center;
		background: none !important;
		:nth-child(1) {
			margin: 5px;
			margin-left: 0; 
		}
		:nth-child(2) {
			margin: 5px;
			margin-right: 0;
		}
		.grid-item {
			width: 50%;
			line-height: 50px;
		    margin-bottom:5px;
			background: #FFF;
			padding: 5px;
			border-radius: 5px;
			    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
			.icon {
			    display: flex;
			    align-items: center;
			    justify-content: center;
			    height: 51px;
			    background: no-repeat 50% 50%/6.93333vw 6.93333vw;
			}
			img{
				vertical-align: top;
				width: 36px;
				margin: 5px;
			}
			span{
				font-size: 16px;
				color: #fa9832;
			}
		}
	}
	.banner {
	   height: 52px;
	   display: flex;
	   width: 100%;
	   background: none;
	   background-size: 100% 100%;
	   position: relative;
	   flex-direction: column;
		p {
		    padding: 67px 0 0 52px;
		    font-size: 15px;
		    color: #b4ffec;
		    font-weight: 500;
		}
		>div {
		    padding: 10px 0 0 52px;
			font-size: 24px;
			font-weight: 700;
			position: relative;
			display: flex;
			z-index: 2;
			align-items: center;
			>span {
			    font-size: 16px;
			    margin-left: 5px;
			}
		}
		.notice {
			height: 52px;
			padding: 0;
			font-size: 14px;
			font-weight: 400;
			display: block;
			width: 100%;
			color: #727d91;
			// background: linear-gradient(270deg, #0c7f9e, #ffd543);
			.icon {
				width: 35px;
				height: 35px;
				line-height: 35px;
				text-align: center;
				
				border-radius: 35px;
				margin-top: 1.2vh;
				margin-left: 2%;
				img {
				    width: 40px;
				    position: absolute;
				    top: 8px;
				    left: 8px;
				}
			}
			.text {
			   position: absolute;
			   left: 48px;
			   top: 1px;
			   right: 0;
			   line-height: 35px;
			   height: 35px;
			   border-radius: 5%;
			   padding: 0 3%;
			   margin-right: 3%;
			   margin-top: 1vh;
			   padding-left: 0;
			}
		}
	}
	.van-col{
		text-align: left;
		
		div{
			color: #323232;
			font-size: 14px;
			line-height: 25px;
			height: 25px;
		}
		div:first-child{
			margin-top: 5px;
		}
		div:last-child{
			color: red;
		}
	}
	.van-col:first-child{
		img{
			width: 50px;
			height: 50px;
			margin:5px 15px;
		}
	}
	.inviteItem{
		padding: 0px 6px 0px 20px;
		margin-bottom: 1vh;
		display: flex;
		justify-content: space-between;
		align-items: center;
		text-align: left;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		.text{
		    color: #818181;
		    font-size: 15px;
			margin-top: 12px;
			text-align: left;
		}
		.value{
		    color: #ffa044;
		    font-size: 18px;
		    margin-top: 12px;
			text-align: left;
		}
		.f44 {
		    font-size: 25px;
		}
		.f20 {
		    font-size: 12px;
			margin-top: 12px;
		}
	}
	.bglight, .bglight2 {
	    background: linear-gradient(90deg,#fdebd5,#fff5ec)!important;
	}
	.index_menu ul{display: flex; flex-wrap: wrap;}
	.index_menu ul li{width: 25%; display: flex; align-items: center; flex-direction: column; margin: 1px 0 8px;}
	.index_menu ul li .img{
		background: #fff; 
		width: 60px; 
		height: 60px; 
		border-radius: 100%; 
		display: flex; 
		align-items: center; 
		justify-content: center;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1) !important;
	}
	.index_menu ul li img{display: block; height: 30px; }
	.index_menu ul li p{color:#000; margin-top: 5px; text-align: center;}


	#app3 {
		width: 100%;
		height: 520px;
		overflow: hidden;
		position: relative;
		padding-left: 5%;
	  .scross {
	    position: relative;
	    top: 0;
	  }
	  
	  .list {
	    height: 92px;
	    line-height: 92px;
	    text-align: center;
	    // background-color: #f1f1f1;
	    margin-bottom: 0;
	  }
	  .list,.val{
	      display: flex;
	      align-items: center; 
	      // border-bottom: 1px solid #f5f5f5;
	      padding:0 10px;
	      width: 100%;
	  }
	  .list>.val>.lef{
	      margin-right:8px;
	      display: inline-block;
	      width: 50px;
	      height: 50px;
	      overflow: hidden;
	  }
	  .list>.val>.lef>img{
	      display: inline-block;
	      width: 50px;
	      height: 50px;
	      border-radius: 50%;
	      /*background: red;*/
	  
	  
	  }
	  .list>.val>.rig>.nav{
	     font-size: 14px;
	     font-weight: bold;
	     margin-bottom: 6px;
	  }
	  .list>.val>.rig>.navVal{
	      font-size: 12px;
	  	text-align: left;
	      margin-bottom: 6px;
	   }
	   .list .rig{
	  	 line-height: 20px;
	   }
	}
	
	.rank{
	  background: #fff;
	}
	.titList{
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    border-bottom: 1px solid #f5f5f5;
	    box-sizing: border-box;
	}
	.titList>.name{
	    flex:1;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    height:40px;
	    background: #989898;
	    color:#fff;
	
	}
	.actives{
	    background: #c4c3c3 !important;
	}
	.titList>.name>img{
	    width:20px;
	    height:20px;
	    /*background: red;*/
	    margin-right:5px;
	}
	.tabsList {
	    margin: 10px 0px;
	   ul {
	       display: flex;
	       flex-wrap: wrap;
	       justify-content: space-between;
	   }
	    ul li {
		   width: 33.33%;
		   font-size: 14px;
		   text-align: center;
		   margin-bottom: 5px;
		   padding: 5px 10px;
	   }

	   ul li:nth-of-type(1) img {
		   background: linear-gradient(rgb(255, 145, 50), rgb(253, 213, 177));
	   }

	   ul li:nth-of-type(2) img {
		   background: linear-gradient(rgb(99, 52, 254), rgb(190, 171, 253));
	   }

	   ul li:nth-of-type(3) img {
		   background: linear-gradient(rgb(255, 50, 132), rgb(252, 170, 202));
	   }

	   ul li:nth-of-type(4) img {
		   background: linear-gradient(rgb(196, 195, 195), rgb(102, 157, 255));
	   }

	   ul li:nth-of-type(6) img {
		   background: linear-gradient(rgb(102, 157, 255), rgb(102, 157, 255));
	   }

	   ul li div {
		   color: #333;
		   font-size: 12px;
		   line-height: 20px;
	   }

	   ul li img {
		   display: inline-block;
		   width: 60px;
		   height: 60px;
		   border-radius: 8px;
		   margin-bottom: 3px;
		   box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	   }
	}
	
	.user_money{
		display: block;
		width: 94%;
		margin-left: 3%;
	    background-color: #fff;
	    border-radius: 10px;
	    padding: 10px 15px 5px 15px;
	    margin-top:5px;
	    // background: url(../images/user/smallBackground.png) no-repeat;
	    background-size: cover;
	    background-position: 50%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		justify-content: space-between;
		text-align: center;
		.money_num{
		    width: auto;
		    height: 40px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    font-size: 12px;
			p{
				margin: 10px 0;
			}
			div{
				width: 100%;
			}
			p:nth-child(2){
				font-size: 14px;
				color: #d3d5d6;
			}
			p:nth-child(1){
				font-size: 18px;
				font-weight: 700;
				color: #FFFFFF;
			}
			>div:first-child {
			    // display: flex;
			    align-items: center;
				img{
				    width: 20px;
				    height: 20px;
					display: inline-block;
					overflow: hidden;
					position: relative;
				}
				p{
					font-weight: bold;
					color: #000000e6;
					font-size: 17px;
					margin: 0px 5px;
				}
			}
		}
		.user_but{
		    display: flex;
		    justify-content: space-around;
		    align-items: center;
			.but_click{
			    width: 45%;
			    height: 40px;
			    border-radius: 10px;
			    display: flex;
			    align-items: center;
			    justify-content: center;
			}
		}
		.border-left-dotted {
		    border-left: 1px dashed rgba(0, 0, 0, 0.1) !important;
		}
		
		.border-top, .border-left, .border-bottom, .border-right {
			border-color: rgba(0, 0, 0, 0.1) !important;
		}
		.card-body {
		    -ms-flex: 1 1 auto;
		    flex: 1 1 auto;
		    min-height: 1px;
			padding: 15px;
			border-bottom: solid 1px;
			margin-bottom: 15px;
			padding-top: 0px;
			padding-bottom: 10px;
		}
		.row {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    margin-right: -15px;
		    margin-left: -15px;
		}
		.col {
		    -ms-flex-preferred-size: 0;
		    flex-basis: 0;
		    -ms-flex-positive: 1;
		    flex-grow: 1;
		    max-width: 100%;
			text-align: left;
		}
		.font-weight-normal {
		    font-weight: 400!important;
		}
		.mb-0, .my-0 {
		    margin-bottom: 0!important;
		}
		h3 {
		    font-size: 20px;
			line-height: 30px;
		}
		.col-auto {
		    -ms-flex: 0 0 auto;
		    flex: 0 0 auto;
		    width: auto;
		    max-width: 100%;
		}
		.text-mute {
		    opacity: 0.7;
			font-size: 14px;
			line-height: 18px;
		}
	}
	/deep/ .van-cell {
		 padding: 10px 8px;
	}
	.ifm {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 5px 5% 0 5%;
	}

	.ifm .left div:last-child {
		margin-top: 5px;
		font-size: 12px;
		padding: 0 10px 0 0;
	}

	.ifm div span:first-child {
		font-weight: bold;
		font-size: 20px;
	}

	.ifm div span:last-child {
		font-weight: bold;
		font-size: 16px;
		color: #fc494d;
		margin-left: 40px;
	}

	.ifm img {
		display: flex;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	}
</style>
